export default "__VITE_ASSET__BHH9u_Yf__"